import { render, staticRenderFns } from "./MobileTopup.vue?vue&type=template&id=10e13474&"
import script from "./MobileTopup.vue?vue&type=script&lang=js&"
export * from "./MobileTopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports